export const Barcode = () => {
  return (
    <svg width='60' height='10' viewBox='0 0 60 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='2.18182' height='10' fill='#616975' />
      <rect opacity='0.2' x='7.63477' width='1.09091' height='10' fill='#616975' />
      <rect opacity='0.2' x='15.2734' width='10.9091' height='10' fill='#616975' />
      <rect opacity='0.5' x='41.4551' width='4.36364' height='10' fill='#616975' />
      <rect x='34' width='2' height='10' fill='#616975' />
      <rect opacity='0.5' x='51' width='2' height='10' fill='#616975' />
      <rect x='55.6367' width='4.36364' height='10' fill='#616975' />
    </svg>
  );
};
